import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-border bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center mb-4">
            <span className="heading-display text-[1.65rem] leading-none text-foreground">
              Compost Developer
            </span>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed">
              iPhone in the yard. Desktop in the office. Photograph the thermometer, save the recipe, see every pile.
            </p>
          </div>

          {/* Product */}
          <div>
            <h3 className="text-sm font-semibold text-foreground mb-4">Product</h3>
            <ul className="space-y-2">
              <li><a href="#features" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Features</a></li>
              <li><a href="#compliance" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Compliance</a></li>
              <li><a href="#pricing" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Pricing</a></li>
              <li><Link to="/book-demo" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Book a Demo</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-sm font-semibold text-foreground mb-4">Company</h3>
            <ul className="space-y-2">
              <li><a href="mailto:rodolfo@bettersystems.ai" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Contact Us</a></li>
              <li><span className="text-sm text-muted-foreground">rodolfo@bettersystems.ai</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-muted-foreground">
            &copy; {new Date().getFullYear()} CompostDeveloper. All rights reserved.
          </p>
          <p className="text-xs text-muted-foreground">
            A product of <a href="https://bettersystems.ai" target="_blank" rel="noopener noreferrer" className="text-forest-500 hover:text-forest-400 transition-colors">Better Systems AI</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
